import React from 'react'
import About from '../components/About'

function AboutComp() {
  return (
<>

<About/>
</>  )
}

export default AboutComp